/* WLG Sticky Header — adds .is-scrolled class on scroll.
 *
 * Oscillation fix (July 2026):
 * The compact (.is-scrolled) state shrinks the header, which shortens the
 * document and can drop window.scrollY back below the threshold — with a
 * single threshold that re-expands the header, which re-raises scrollY,
 * looping forever (header visibly "shakes" big/small at mid-scroll).
 *
 * Fix: hysteresis. Two thresholds with a dead-band wider than the header's
 * height delta, so the height change alone can never flip the state back:
 *   - compact  when scrollY > 100
 *   - expand   when scrollY < 30
 *   - 30..100  -> keep current state
 */
(function () {
  var COMPACT_AT = 100;
  var EXPAND_AT = 30;

  function init() {
    var section = document.querySelector('.section-header');
    if (!section) return;
    var announcement = document.querySelector('.announcement-bar-section');
    var ticking = false;

    function syncAnnouncementHeight() {
      if (!announcement) return;
      var h = announcement.offsetHeight;
      if (h > 0) {
        /* Consumed by wlg-custom.css (.section-header sticky offset, ~:611). */
        document.documentElement.style.setProperty('--wlg-announcement-h', h + 'px');
      }
    }

    function update() {
      var y = window.scrollY;
      if (y > COMPACT_AT) {
        section.classList.add('is-scrolled');
      } else if (y < EXPAND_AT) {
        section.classList.remove('is-scrolled');
      }
      // Between EXPAND_AT and COMPACT_AT: leave the class untouched.
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncAnnouncementHeight, { passive: true });
    syncAnnouncementHeight();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
